module.exports = __webpack_public_path__ + "static/media/1011981.2325b0e5.png";